<script setup lang="ts">
// types
interface DxLoaderBlockProps {
  blocked: boolean;
}

// props
defineProps<DxLoaderBlockProps>();
</script>

<template>
  <transition name="fade">
    <div v-if="blocked" class="blocking-overlay"></div>
  </transition>
</template>

<style scoped lang="scss">
.blocking-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000000;
  pointer-events: auto; /* Set pointer-events to "auto" to block user interaction */
}

.app-dark {
  .blocking-overlay {
    background: rgba(0, 0, 0, 0.3);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s; /* Adjust the duration as needed */
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
